var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex"},[_c('audio',{staticStyle:{"width":"100%"},attrs:{"controls":"","controlsList":"nodownload"}},[_c('source',{attrs:{"src":_vm.url}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }